import { render, staticRenderFns } from "./CanvasStd.vue?vue&type=template&id=2b1b7390&"
import script from "./CanvasStd.vue?vue&type=script&lang=js&"
export * from "./CanvasStd.vue?vue&type=script&lang=js&"
import style0 from "./CanvasStd.vue?vue&type=style&index=0&id=2b1b7390&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports